import React, { useContext } from 'react';
import Modal from '../Modal/index.js';
import { T as Table } from '../../Table-LdWI5rGH.js';
import { g as getLabel, G as Gallery } from '../../Gallery-lGbUPTvY.js';
import { S as SizeChart } from '../../SizeChart-PqebL4MS.js';
import { useTranslation } from 'next-i18next';
import { CoreContext } from '../../context/index.js';
import { c as classnames } from '../../index-2586sEvh.js';
import '../OnlyUIRender/index.js';
import '../Modal/ModalContent/index.js';
import 'react-dom';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import '../../index-QrdBfapu.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-5CMab_Gs.js';
import '../../hooks/useAutoFocus.js';
import '../../index-vPolXUOt.js';
import 'i18next';
import 'react-i18next';
import '../../index-7BRgQqgo.js';
import 'next/router';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import 'notistack';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-qyZpLI0y.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import '../../cookies-l-jEMp6P.js';
import 'lodash';
import '../../utils/currency.js';
import '../../utils/price.js';
import 'number-currency-format';
import 'next/server';
import '../../index-Oip0gjfj.js';
import '../../graphqlRequestClient-7kdUKc_c.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../utils/isBot.js';
import '../../utils/fetchPolicyLookup.js';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import '../Modal/ModalHeader/index.js';
import '../../utils/logToRelic.js';

const InfoVariantModal = ({ content, sizeChartData, onClose, sku }) => {
    var _a;
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const isSizeChart = content === 'size_chart';
    const data = isSizeChart ? content : JSON.parse(content);
    let title = isSizeChart ? tLabel('beddingSizeGuide') : '';
    const uniqueClass = ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.uniqueClass) ? data.data.uniqueClass : '';
    const { data: { locale }, } = useContext(CoreContext);
    if (data.type === 'gallery') {
        title = getLabel(data.data.titleText, locale);
    }
    return (React.createElement(Modal, { open: true, title: title, maxWidth: isSizeChart ? 'lg' : 'xl', className: classnames('base-info-variant-modal', sku === null || sku === void 0 ? void 0 : sku.toLocaleLowerCase(), uniqueClass), onClose: onClose }, isSizeChart ? (React.createElement(SizeChart, { sizeChartData: sizeChartData })) : (React.createElement(React.Fragment, null,
        data.type === 'table' && React.createElement(Table, { item: data }),
        data.type === 'gallery' && React.createElement(Gallery, { item: data })))));
};

export { InfoVariantModal as default };
//# sourceMappingURL=index.js.map
